// Script from http://www.quirksmode.org/js/detect.html
// TODO: Use https://github.com/ded/bowser instead ?

/** APP TEMPLATE PACKAGE *************************************************/
var app = app || (function() {
    return {};
})();

/*** NEWS MANAGEMENT - SUB APP PACKAGE ************************/
app.browser = app.browser ||
(function() {

    /* ----- Private variables and methods ---- */
    var dataBrowser = [
        // For Microsoft Edge. IMPORTANT: Let it at the begining because its user-agent integrate all the keywords of others browsers (Chrome, Safari,...)
        {
            string: navigator.userAgent,
            subString: "Edge",
            versionSearch: "Edge",
            identity: "Edge"
        },
        {
            string: navigator.userAgent,
            subString: "Chrome",
            identity: "Chrome"
        },
        {
            string: navigator.userAgent,
            subString: "CriOS",
            versionSearch: "CriOS",
            identity: "Chrome"
        },
        {
            string: navigator.userAgent,
            subString: "OmniWeb",
            versionSearch: "OmniWeb/",
            identity: "OmniWeb"
        },
        {
            string: navigator.vendor,
            subString: "Apple",
            identity: "Safari",
            versionSearch: "Version"
        },
        {
            prop: window.opera,
            identity: "Opera",
            versionSearch: "Version"
        },
        {
            string: navigator.vendor,
            subString: "iCab",
            identity: "iCab"
        },
        {
            string: navigator.vendor,
            subString: "KDE",
            identity: "Konqueror"
        },
        {
            string: navigator.userAgent,
            subString: "Firefox",
            identity: "Firefox"
        },
        {
            string: navigator.vendor,
            subString: "Camino",
            identity: "Camino"
        },
        { // for newer Netscapes (6+)
            string: navigator.userAgent,
            subString: "Netscape",
            identity: "Netscape"
        },
        {
            string: navigator.userAgent,
            subString: "MSIE",
            identity: "Explorer",
            versionSearch: "MSIE"
        },
        // For Internet Explorer 11+
        {
            string: navigator.userAgent,
            subString: "Trident",
            identity: "Explorer",
            versionSearch: "rv"
        },
        {
            string: navigator.userAgent,
            subString: "Gecko",
            identity: "Mozilla",
            versionSearch: "rv"
        },
        { // for older Netscapes (4-)
            string: navigator.userAgent,
            subString: "Mozilla",
            identity: "Netscape",
            versionSearch: "Mozilla"
        }
    ];

    var dataOS = [
        {
            string: navigator.platform,
            subString: "Win",
            identity: "Windows"
        },
        {
            string: navigator.platform,
            subString: "Mac",
            identity: "Mac"
        },
        {
            string: navigator.userAgent,
            subString: "iPhone",
            identity: "iPhone/iPod"
        },
        {
            string: navigator.platform,
            subString: "Linux",
            identity: "Linux"
        }
    ];

    return {
        /* ---- Public variables and methods ------ */
        browser: null,
        OS: null,
        version: null,

        init: function() {
            this.browser = this.searchString(dataBrowser) || "An unknown browser";
            this.version = this.searchVersion(navigator.userAgent)
                || this.searchVersion(navigator.appVersion)
                || "an unknown version";
            this.OS = this.searchString(dataOS) || "an unknown OS";
        },

        searchString: function(data) {
            for (var i = 0; i < data.length; i++) {
                var dataString = data[i].string;
                var dataProp = data[i].prop;
                this.versionSearchString = data[i].versionSearch || data[i].identity;
                if (dataString) {
                    if (dataString.indexOf(data[i].subString) != -1)
                        return data[i].identity;
                }
                else if (dataProp)
                    return data[i].identity;
            }
        },

        searchVersion: function(dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index == -1) return;
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        },

        checkCurrentBrowserAgainFormula: function(browserCheckFormula) {
            /* 
            Browser formula format looks like that "Explorer == 11, Firefox >= 12, Safari > 5, *"  
            The last "*" means other browsers are allowed. If it is absent, they are not allowed.
            */ 
            
            var browserCheckFormulas = browserCheckFormula.split(",");
            var isBrowserConcerned = false;
            var isBrowserVersionCorrect = true;
            var areOtherBrowsersAllowed = false;

            for (var i = 0; i < browserCheckFormulas.length; i++) {
                var value = browserCheckFormulas[i];

                if (/ *\* */.exec(value)) {
                    // "*" string detected
                    areOtherBrowsersAllowed = true;
                    continue;
                }

                var regexp = new RegExp("^ *([A-Za-z]+) *([^A-Za-z ]+) *([0-9]+) *$");

                if (!value.match(regexp)) {
                    // Not valid string => ignore
                    continue;
                }

                var checkElements = regexp.exec(value);
                var browserId = checkElements[1];
                var comparator = checkElements[2];
                var browserVersion = checkElements[3];

                if (this.browser === browserId) {
                    isBrowserConcerned = true;
                    switch (comparator) {
                    case '==':
                        isBrowserVersionCorrect &= (this.version === browserVersion);
                        break;
                    case '<':
                        isBrowserVersionCorrect &= (this.version < browserVersion);
                        break;
                    case '<=':
                        isBrowserVersionCorrect &= (this.version <= browserVersion);
                        break;
                    case '>':
                        isBrowserVersionCorrect &= (this.version > browserVersion);
                        break;
                    case '>=':
                        isBrowserVersionCorrect &= (this.version >= browserVersion);
                        break;
                    case '!=':
                        isBrowserVersionCorrect &= (this.version !== browserVersion);
                        break;
                    default:
                        isBrowserVersionCorrect = false;
                        break;
                    }
                }
            }
            
            var isWrongBrowser = ((isBrowserConcerned && !isBrowserVersionCorrect) ||
                (!isBrowserConcerned && !areOtherBrowsersAllowed));

            return !isWrongBrowser;
        }
    };
})();